import { render, staticRenderFns } from "./ProjectUploadBomModal.vue?vue&type=template&id=24056a89&"
import script from "./ProjectUploadBomModal.vue?vue&type=script&lang=js&"
export * from "./ProjectUploadBomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports